import { useEffect } from "react";
import { Spin } from "antd";
import { useLinkedInLogin } from "../../hooks/useLinkedInLogin";

const LinkedInCallback = () => {
  const { handleLinkedInCallback, loading, error } = useLinkedInLogin();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const errorParam = params.get("error");
    
    if (errorParam) {
      console.error("LinkedIn OAuth error:", errorParam);
      // Redirect back to signup page with error
      window.location.href = "/signup?error=linkedin_auth_failed";
    } else if (code && state) {
      handleLinkedInCallback(code, state);
    } 
    else {
      console.error("Missing code or state parameter");
    }
  }, [handleLinkedInCallback]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Spin size="large" />
      <div style={{ fontSize: "16px", color: "#464758" }}>
        {error ? error : "Completing LinkedIn authentication..."}
      </div>
      {error && (
        <a href="/signup" style={{ color: "#3F67AD", textDecoration: "underline" }}>
          Return to Sign Up
        </a>
      )}
    </div>
  );
};

export default LinkedInCallback;